import { Button, Dropdown, Input, Menu, Space, Table, Modal } from 'antd';
import React, { useCallback, useState, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import moment from 'moment';

import { FETCH_ADMIN_PROPOSALS } from 'graphql/queries/adminQueries';

const limit = 10;

const ProposalDetails = () => {
  const [adminProposals, setAdminProposals] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [cursorPaging, setCursorPaging] = useState(null);
  const [isFetching, setIsFetching] = useState(true);

  const updateAdminProposals = (proposals, shouldConcat = false) => {
    const newProposals = proposals.map((proposal) => ({
      createdAt: moment(proposal.date).format('DD/MM/YYYY'),
      lang: proposal.language,
      font: `${proposal?.draft?.titleFont?.family ?? 'default'} / ${
        proposal?.draft?.bodyFont?.family ?? 'default'
      }`,
      state: proposal.state || 'edit',
      uid: proposal.uid,
      ids: [proposal._id, proposal.pid, proposal.cid],
      actions: proposal,
      key: proposal._id,
    }));
    setAdminProposals([...(shouldConcat ? adminProposals : []), ...newProposals]);
  };

  const processFetchedData = (data, shouldConcat = false) => {
    if (data?.fetchAdminProposals) {
      const { proposals, pagingMetadata } = data.fetchAdminProposals;

      updateAdminProposals(proposals, shouldConcat);
      setCursorPaging(pagingMetadata);
    }

    setIsFetching(false);
  };

  const [fetchAdminProposals, { refetch, fetchMore }] = useLazyQuery(FETCH_ADMIN_PROPOSALS, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => processFetchedData(data),
  });

  useEffect(() => {
    setIsFetching(true);
    fetchAdminProposals({
      variables: {
        queryString: searchText,
        limit: limit,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  const loadMore = async () => {
    setIsFetching(true);
    const { data } = await fetchMore({
      variables: {
        queryString: searchText,
        limit: limit,
        cursorPaging: cursorPaging?.cursor,
      },
    });
    processFetchedData(data, true);
  };

  const refetchProposals = async () => {
    setIsFetching(true);

    const { data } = await refetch({ queryString: searchText, limit: limit });
    processFetchedData(data);
  };

  const handleReset = () => {
    setSearchText('');
  };

  const handleToggleFake = (prop) => {
    // Meteor.call('toggleFake', { pId: prop._id, fake: !prop.fake }, e => {
    //   if (e) {
    //     message.error('Failed to execute');
    //   } else {
    //     const propIndex = proposals.findIndex(el => el._id === prop._id);
    //     const newProp = prop;
    //     newProp.fake = !prop.fake;
    //     proposals[propIndex] = newProp;
    //     setProposals([...proposals]);
    //     message.success('Success');
    //   }
    // });
  };

  const menu = useCallback(
    (prop) => (
      <Menu>
        <Menu.Item key="fake" onClick={() => handleToggleFake(prop)}>
          {prop.fake ? 'Mark not fake' : 'Mark fake'}
        </Menu.Item>
        <Menu.Item
          key="download"
          onClick={() => {
            // Meteor.call(
            //   'downloadPDF',
            //   { origin: window.location.origin, propid: prop._id },
            //   (e, r) => {
            //     if (e) {
            //       message.error('Failed to download PDF');
            //     } else {
            //       window.open(r, '_blank');
            //     }
            //   }
            // );
          }}>
          Download PDF
        </Menu.Item>
        <Menu.Item
          key="unsign"
          onClick={() => {
            Modal.confirm({
              title: `Are you sure you want to unsign proposal`,
              onOk: () => {
                // Meteor.call('unsignProp', prop._id, e => {
                //   if (e) {
                //     message.error(`Failed to unsign prop`);
                //   } else {
                //     message.success(`Successfully unsigned prop`);
                //   }
                // });
              },
            });
          }}>
          Unsign prop
        </Menu.Item>
      </Menu>
    ),
    []
  );

  const propColumn = [
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
    },
    {
      title: 'Lang',
      dataIndex: 'lang',
      key: 'lang',
    },
    {
      title: 'Font',
      dataIndex: 'font',
      key: 'font',
    },
    {
      title: 'State',
      dataIndex: 'state',
      key: 'state',
    },
    {
      title: 'User ID',
      dataIndex: 'uid',
      key: 'uid',
    },
    {
      title: 'ID/PID/CID',
      dataIndex: 'ids',
      key: 'ids',
      render: (ids) => (
        <div>
          {ids.map((el, i) => (
            <div key={i}>{el}</div>
          ))}
        </div>
      ),
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      key: 'actions',
      render: (details) => (
        <Dropdown overlay={menu(details)} trigger="click" placement="bottomRight" arrow>
          <Button type="link">Action</Button>
        </Dropdown>
      ),
    },
  ];

  return (
    <div>
      <div className="admin-table-wrapper">
        <div className="table-action">
          <h3>All Props</h3>
          <div>
            <Space>
              <Input.Search
                width="200"
                placeholder="Email/Uid"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                onSearch={refetchProposals}
              />
              <Button type="primary" onClick={handleReset}>
                Reset
              </Button>
            </Space>
          </div>
        </div>
        <Table
          loading={isFetching}
          dataSource={adminProposals}
          columns={propColumn}
          pagination={false}
          footer={() => (
            <div>
              {cursorPaging?.hasNext && (
                <Button
                  loading={isFetching}
                  disabled={isFetching}
                  className="medium-btn white-btn"
                  onClick={loadMore}>
                  Load more
                </Button>
              )}
            </div>
          )}
        />
      </div>
    </div>
  );
};

export default ProposalDetails;
